export const stripTag = (html: string) => {
  const regex = /(<([^>]+)>)/gi;
  return html.replace(regex, '');
};

export const camelCase = (str: string) => {
  return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
    return word.toUpperCase();
  });
};

export const titleCleansing = (str: string) => {
  // remove 'tag'
  if (str.indexOf('tag') > -1 || str.indexOf('Tag') > -1) {
    return str.replace(/[tT]ag/g, '');
  }
};

export const getNameFromPath = (path: string) => {
  return path.replace(/^.*[\\\/]/, '').replace(/\.[^.]*?$/, '');
};

export const constructTagString = (str: string) => {
  if (str === str.toUpperCase()) {
    return str.toUpperCase();
  } else {
    return camelCase(str);
  }  
}
